import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/site/ContactSection.css';

const ContactSection = ({ title, subtitle, description }) => {
  return (
    <section className="contact-section">
      <div className="container">
        <div className="contact-content">
          <div className="contact-text">
            <h2 className="section-title">{title}</h2>
            <h3 className="section-subtitle">{subtitle}</h3>
            <p className="section-description">{description}</p>

            <div className="contact-methods">
              <a href="https://wa.me/5511XXXXXXXXX" className="contact-method whatsapp" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i>
                <span>WhatsApp</span>
              </a>
              <a href="https://instagram.com/roboliviam" className="contact-method instagram" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
                <span>Instagram</span>
              </a>
            </div>
          </div>

          <div className="contact-form-container">
            <div className="contact-form-wrapper">
              <h3 className="form-title">Envie uma mensagem</h3>
              
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Nome</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    placeholder="Seu nome" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    placeholder="Seu email" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Assunto</label>
                  <select id="subject" name="subject" required>
                    <option value="">Selecione um assunto</option>
                    <option value="duvida">Dúvida sobre o serviço</option>
                    <option value="suporte">Suporte técnico</option>
                    <option value="feedback">Feedback</option>
                    <option value="parceria">Proposta de parceria</option>
                    <option value="outro">Outro assunto</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Mensagem</label>
                  <textarea 
                    id="message" 
                    name="message" 
                    placeholder="Sua mensagem" 
                    rows="5"
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn btn-primary btn-block">
                  Enviar mensagem
                </button>
              </form>
              
              <div className="form-footer">
                <p>Responderemos em até 24 horas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="cosmic-decoration">
        <div className="stars-bg"></div>
      </div>
    </section>
  );
};

export default ContactSection;